import React from 'react';
import { useGlobalContext } from '../context';

import CartContainer from '../component/CartContainer';
import Loading from '../component/Loading';
import { Container } from 'react-bootstrap';

export default function Cart(props) {
  const { loading } = useGlobalContext();

  if (loading) {
    return (
      <div className='loading'>
        <Loading />
      </div>
    );
  }
  return (
    <Container>
      <div className='cart-container'>
        <CartContainer />
      </div>
    </Container>
  );
}
